module.exports = __webpack_public_path__ + "static/media/la.52881427.svg";